/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'
import useGlobalFields from './useGlobalFields'

export default function useLoginFields({form, prefix = ''}) {
    const {formatMessage} = useIntl()

    const {
        control,
        formState: {errors}
    } = form

    const {email} = useGlobalFields({
        form,
        prefix
    })

    const fields = {
        email,
        password: {
            name: `${prefix}password`,
            label: formatMessage({
                defaultMessage: 'Password',
                id: 'use_login_fields.label.password'
            }),
            placeholder: formatMessage({
                defaultMessage: 'Password',
                id: 'use_login_fields.label.password'
            }),
            defaultValue: '',
            type: 'password',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your password.',
                    id: 'use_login_fields.error.required_password'
                })
            },
            error: errors[`${prefix}password`],
            inputProps: {
                autoComplete: 'current-password'
            },
            control
        }
    }

    return fields
}
